const steps = [
    {
        element: '.w-collapse-btn',
        popover: {
            title: '控制按钮',
            description: '打开或者收起 左侧菜单栏',
            position: 'bottom'
        }
    },
    {
        element: '.w-breadcrumb',
        popover: {
            title: '面包屑',
            description: '展示当前的 菜单',
            position: 'bottom'
        }
    },
    {
        element: '.screenfull-main',
        popover: {
            title: '全屏',
            description: '控制页面 进入/退出 全屏',
            position: 'left'
        }
    },
    // {
    //     element: '.international-icon',
    //     popover: {
    //         title: 'Switch language',
    //         description: 'Switch the system language',
    //         position: 'left'
    //     }
    // },
    // {
    //     element: '.theme-switch',
    //     popover: {
    //         title: 'Theme Switch',
    //         description: 'Custom switch system theme',
    //         position: 'left'
    //     }
    // },
    {
        element: '.tags-main',
        popover: {
            title: 'Tags view',
            description: '展示访问过的页面, 页面当前默认缓存， 对于子菜单页面 需要在 第一个子菜单页面右键刷新才会清除全部子菜单页面缓存效果',
            position: 'bottom'
        },
        padding: 0
    }
]

export default steps
